export function isDeepEqual(value1: any, value2: any): boolean {
    if (value1 === value2) {
        return true;
    }

    if (value1 === null || value2 === null || typeof value1 !== 'object' || typeof value2 !== 'object') {
        return false;
    }

    if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
            return false;
        }
        for (let i = 0; i < value1.length; i++) {
            if (!isDeepEqual(value1[i], value2[i])) {
                return false;
            }
        }
        return true;
    }

    if (Array.isArray(value1) || Array.isArray(value2)) {
        return false;
    }

    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (!isDeepEqual(value1[key], value2[key])) {
            return false;
        }
    }

    return true;
}
